import {
  display,
  fontSize,
  fontStyle,
  fontWeight,
  spacing,
  styled,
} from "@mui/system";
import { Box } from "@mui/material";

const BreadcrumbsSyles = styled(Box)(({ theme }) => ({
  "& .crumbLink": {
    display: "flex",
    textDecoration: 'none',  // Remove underline
    color: 'inherit',        // Inherit the color from parent, or set a specific color
    '&:visited': {
      color: 'inherit',      // Prevent color change when visited

    },
  },
  "& .crumbText": {
    fontSize: theme.typography.pxToRem(12),
  },
  "& .MuiBreadcrumbs-separator": {
    fontSize: theme.typography.pxToRem(12),
  },
}));

export default BreadcrumbsSyles;
